import { detailsPanelStore } from 'stores/detailsPanelStore/detailsPanelStore'

export const refreshTheDetailsPanelData = () =>
  detailsPanelStore.setState((s) => ({ ...s, keyForRefreshing: new Date().toISOString() }))
